import './MultiSelectFilterForm.css';
import * as React from 'react';
import { MdClose as CloseIcon } from 'react-icons/lib/md';
import { t } from 'i18next';

const MultiSelectFilterForm = (label, fetchPossibleValues) => class extends React.Component {
  constructor(props) {
    super(props);
    this.possibleValues = fetchPossibleValues && (! fetchPossibleValues.hasOwnProperty('message'))
        ? fetchPossibleValues[0].values : [];
  }

  render() {
    const { updateCurrent, current } = this.props;
    const allCurrent = (Array.isArray(current) ? current : []).reduce((a, e) => (
      a.indexOf(e) < 0 && e.length ? [...a, e.trim()] : a), []);
    const unusedPossibleValues = this.possibleValues.filter(e => allCurrent.indexOf(e) < 0);
    let dropdown;

    return (
      <div className="MultiSelectFilterForm">
        <div className="entries">
          {allCurrent.map(entry => (
            <div className="Entry"
              key={entry}
            >
              {entry}
              <CloseIcon size="20"
                onClick={() => updateCurrent(allCurrent.filter(e => e !== entry))}
              />
            </div>
          ))}

        </div>
        <select ref={i => dropdown = i}
          onChange={(e) => {
            if (e.target.value) {
              updateCurrent([...allCurrent, e.target.value]);
              dropdown.selectedIndex = 0;
            }
          }}
        >
          <option default
            value={null}
          >
            {t(`filters.placeholder.${label}`)}

          </option>
          {unusedPossibleValues.map(v => (
            <option key={v}
              value={v}
            >
              {v}

            </option>
          ))}
        </select>
      </div>
    );
  }
};

export default MultiSelectFilterForm;
